<template>
    <div ref="containerRef" class="timeline-container">
      <div class="carousel-wrapper">
        <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
          <!-- Hotel 1 -->
          <div ref="hotelCardRef" class="hotel-card">
            <p ref="tituloRef" class="recomendacion-hospedaje">Hospedaje.</p>
            <p ref="descripcionRef">Recomendación.</p>
            <img
              ref="imagenRef"
              :src="require('@/assets/hotel1.jpg')"
              alt="Park Inn"
              class="hotel-image rounded-circle"
            >
            <div ref="infoRef" class="hotel-info">
              <h3>LA QUINTA BY WYNDHAM</h3>
              <strong>Dirección:</strong><br>
              <p>Av.Ejercito Nacional, Partido Iglesias <br> Cd. Juárez, Chihuahua.</p>
              Reservaciones: Alejandra Ceja<br>
              <p><i class="fas fa-phone" /> (237) 119-21-29</p>
              <strong>Código Convenio: <br><br>MONTSERRAT 30/05/25</strong>
              <a
                ref="botonRef"
                href="https://maps.app.goo.gl/dbfVXkzkqpmtik2PA"
                class="modern-button"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ubicación <i class="fas fa-map-marker-alt" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { gsap } from 'gsap';
  
  export default {
    name: 'HospedajeVue',
    data() {
      return {
        currentIndex: 0
      };
    },
    setup() {
      const containerRef = ref(null);
      const hotelCardRef = ref(null);
      const tituloRef = ref(null);
      const descripcionRef = ref(null);
      const imagenRef = ref(null);
      const infoRef = ref(null);
      const botonRef = ref(null);
  
      const animateSection = () => {
        gsap.fromTo(hotelCardRef.value, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' });
        gsap.fromTo(tituloRef.value, { x: -100, opacity: 0 }, { x: 0, opacity: 1, duration: 1, ease: 'power3.out', delay: 0.2 });
        gsap.fromTo(descripcionRef.value, { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 1, ease: 'back.out(1.7)', delay: 0.4 });
        gsap.fromTo(imagenRef.value, { y: 100, opacity: 0 }, { y: 0, opacity: 1, duration: 1.1, ease: 'power2.out', delay: 0.6 });
        gsap.fromTo(infoRef.value, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out', delay: 0.8 });
        gsap.fromTo(botonRef.value, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.8, ease: 'back.out(1.7)', delay: 1 });
      };
  
      onMounted(() => {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            animateSection();
            observer.unobserve(entry.target);
          }
        }, { threshold: 0.3 });
  
        if (containerRef.value) observer.observe(containerRef.value);
      });
  
      return {
        containerRef,
        hotelCardRef,
        tituloRef,
        descripcionRef,
        imagenRef,
        infoRef,
        botonRef
      };
    }
  };
  </script>

  
  <style scoped>
  /* Estilos para el contenedor del carrusel */
  /* Contenedor principal */
  .timeline-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 95vh;
    padding: 0;
    box-sizing: border-box;
    overflow-x: hidden;
    background: linear-gradient(rgba(224, 152, 162, 0.292), rgba(218, 186, 191, 0.402)),
    url('@/assets/122.jpg');    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #fff;
  }
  
  /* Carrusel wrapper */
  .carousel-wrapper {
    position: relative;
    width: 80%;
    overflow: hidden;
  }
  
  /* Carrusel horizontal */
  .carousel {
    display: flex;
    transition: transform 0.5s ease;
  }
  
  /* Card de hotel */
 
  .hotel-card {
    width: 100%;
    max-width: 500px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 30px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.85);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    transition: transform 0.3s ease;
    margin: 0 auto;
  }
  
  .hotel-card:hover {
    transform: scale(1.05);
  }
  
  .hotel-image {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 20px;
  }
  
  .hotel-info {
    font-family: 'Josefin Sans', sans-serif;
    color: rgba(20, 19, 19, 0.9);
  }
  
  .hotel-info h3 {
    font-size: 24px;
    color: #1f1c1c;
  }
  
  .modern-button {
    display: inline-block;
    text-decoration: none;
    font-size: 16px;
    background: #d592b0c5;
    color: #fff;
    border: 2px solid #3c3e31;
    font-family: 'Roboto', cursive;
    padding: 12px 24px;
    border: none;
    border-radius: 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease, background 0.5s ease;
    margin-bottom: 15px;
  }
  
  .modern-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.2);
  }
  
  /* Botones de navegación con animación de eco */
  .carousel-button {
    position: absolute;
    top: 50%;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 2.5rem;
    z-index: 10;
    cursor: pointer;
    transform: translateY(-50%);
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  
  /* Botón izquierdo */
  .carousel-button.left {
    left: 10px;
    animation: moveLeft 1s infinite ease-in-out;
  }
  
  /* Botón derecho */
  .carousel-button.right {
    right: 10px;
    animation: moveRight 1s infinite ease-in-out;
  }
  
  /* Animación de eco para la flecha izquierda */
  @keyframes moveLeft {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    50% {
      transform: translateX(-10px);
      opacity: 0.8;
    }
    75% {
      transform: translateX(-15px);
      opacity: 0.6;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  /* Animación de eco para la flecha derecha */
  @keyframes moveRight {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    50% {
      transform: translateX(10px);
      opacity: 0.8;
    }
    75% {
      transform: translateX(15px);
      opacity: 0.6;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  /* Efecto hover (flechitas aumentan de tamaño y cambian de color) */
  .carousel-button:hover {
    transform: scale(1.5) translateY(-50%);
    opacity: 1;
  }
  
  .carousel-button.left:hover {
    color: #46423a;
  }
  
  .carousel-button.right:hover {
    color: #4d4840;
  }
  .hotel-info h3 {
    font-size: 18px; /* Reducido de 24px a 18px */
    color: #1f1c1c;
  }
  
  .hotel-card p {
    font-size: 14px; /* Reducido de un tamaño mayor a 14px */
    color: #1f1c1c;
  }
  .recomendacion-hospedaje {

  font-family: 'british', sans-serif;
  font-size: 34px !important;
  margin-bottom: 12px;
  color: #434040d7;
}
  </style>
  